<template>
<div>
    <!-- <v-container fluid> -->
        <v-row>
            <v-col cols="12">
                <v-tabs v-model="tab" right>
                    <v-tab v-for="item in items" :key="item.tab">
                        {{item.tabTitle}}
                    </v-tab>
    
            
                </v-tabs>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-tabs-items v-model="tab">
                    <v-tab-item 
                        v-for="item in items"
                        :key="item.tab"
                    >
                        <keep-alive>
                            <component :is="item.component" />
                        </keep-alive>
                </v-tab-item>
            </v-tabs-items>

            </v-col>
        </v-row>
    <!-- </v-container> -->
    
</div>
</template>

<script>
import ManageCosellers from '../components/content/user/ManageCosellers.vue';
import ManageCustomers from '../components/content/user/ManageCustomers.vue';
import Importer from '../components/content/user/Importer.vue';
import BulkImporter from '../components/content/user/BulkImporter.vue';
import Matrix from '../components/content/user/Matrix.vue';

export default {
    name: "Landing",
    components: { ManageCosellers, ManageCustomers, Matrix, Importer, BulkImporter },
    data () {
        return {
            tab: 'matrix',
            items: [
                {
                    tab: 'matrix',
                    tabTitle: 'Matrix',
                    component: Matrix
                },
                {
                    tab: 'manage-cosellers',
                    tabTitle: 'Manage Cosellers',
                    component: ManageCosellers
                },
                {
                    tab: 'manage-customers',
                    tabTitle: 'Manage Customers',
                    component: ManageCustomers
                },
                {
                    tab: 'import-csv',
                    tabTitle: 'Import Data',
                    component: Importer
                },
                {
                    tab: 'bulk-import-csv',
                    tabTitle: 'Bulk Import',
                    component: BulkImporter
                }
            ]
        }
    }
}
</script>

<style scoped>
</style>